import { ProductPrice } from 'modules/Products/drawers/ProductPrice/ProductPrice'
import { useProductPriceOutletConnector } from 'modules/Products/drawers/ProductPrice/useProductPriceOutletConnector'

/**
 * Consolidate this component with the unified pricing editor - or at the
 * very least co-locate it with the unified pricing editor as an alternative
 * drawer to render for the view mode.
 * @returns
 */
export const ProductPriceRouteComponent = () => {
  const { onClose, price } = useProductPriceOutletConnector()

  return <ProductPrice onClose={onClose} price={price} />
}
